import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import {description} from './description'
function Head({ path }) {
  const [PathName, setPathName] = useState("Home");
  const [meta, setMeta] = useState({
    desc:'',
    keywords:''
  })
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);
  const {
    site: {
      siteMetadata: { title },
    },
  } = data;

const metaSetter = (desObject) => {

  switch (path) {
    case "/":
      setMeta({
        keywords: desObject.home.keywords,
        desc: desObject.home.desc,
      });
      break;
    case "/about":
      setMeta({
        keywords: desObject.about.keywords,
        desc: desObject.about.desc,
      });
      break;
    case "/projects":
      setMeta({
        keywords: desObject.projects.keywords,
        desc: desObject.projects.desc,
      });
      break;
    case "/contact":
      setMeta({
        keywords: desObject.contact.keywords,
        desc: desObject.contact.desc,
      });
      break;

    default:
       setMeta({
         keywords: desObject.home.keywords,
         desc: desObject.home.desc,
       });
      break;
  }
  
}

  useEffect(() => {
    if (path === "/") {
      setPathName("Home");
    } else {
      const p = `${path.slice(1)}`;

      setPathName(`${p.toUpperCase()}`);
    }

    metaSetter(description)
  }, [path]);

  return (
    <>
    <Helmet title={`${title} | ${PathName}`} htmlAttributes={{lang:'en'}} >
     <meta name="description" content={meta.desc}/>
     <meta name="keywords" content={meta.keywords}/>
    </Helmet>
    
    </>
  );
}

export { Head };
